
import { CodesDepotHorsMagasin, GroupeTraitementCodes } from 'constants.js';


const isUserFromGroup = (groupeTraitementCode) => {
    let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

    return utilisateurCourant && utilisateurCourant.groupes && utilisateurCourant.groupes.find(x => x.code === groupeTraitementCode) !== undefined;
};


export default {
    getUtilisateurMagasin: () => {
        return isUserFromGroup(GroupeTraitementCodes.Magasin);
    },

    getUtilisateurQualiteEntrepot: () => {
        return isUserFromGroup(GroupeTraitementCodes.QualiteEntrepot);
    },

    getUtilisateurQualiteFournisseur: () => {
        return isUserFromGroup(GroupeTraitementCodes.QualiteFournisseur);
    },

    getUtilisateurComptable: () => {
        return isUserFromGroup(GroupeTraitementCodes.ServiceComptabilite);
    },

    getUtilisateurATC: () => {
        return isUserFromGroup(GroupeTraitementCodes.ATC);
    },

    getUtilisateurManagerCommercial: () => {
        return isUserFromGroup(GroupeTraitementCodes.ManagersCommerciaux);
    },

    isAdmin: () => {

        let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

        return utilisateurCourant && utilisateurCourant.administrateur;
    },

    isAnonymous: () => {

        let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

        return !utilisateurCourant || utilisateurCourant.anonyme;
    },

    getCodeDepot: ({ magasin }) => {

        let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

        if (!utilisateurCourant || !utilisateurCourant.codeDepot || (magasin && CodesDepotHorsMagasin.indexOf(utilisateurCourant.codeDepot) !== -1)) {
            return ''; // On ne préselectionne pas de magasin
        }

        return utilisateurCourant.codeDepot;
    },

    getCodeAgence: () => {

        let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

        if (!utilisateurCourant || !utilisateurCourant.agence) {
            return '';
        }

        return utilisateurCourant.agence.code;
    },

    autoriseSAV: () => {

        let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

        return utilisateurCourant && utilisateurCourant.autoriseSAV;
    },


    afficheBoutonAdministration: () => {

        let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

        return utilisateurCourant && (utilisateurCourant.administrateur || (utilisateurCourant.groupes && utilisateurCourant.groupes.find(x => x.code === GroupeTraitementCodes.QualiteFournisseur) !== undefined));
    },

    getConnexionRepresentant: () => {
        let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

        if (!utilisateurCourant) {
            return false;
        }

        return utilisateurCourant.connexionRepresentant;
    },

    getUtilisateurExclusionControleAgePiece: () => {
        let utilisateurCourant = JSON.parse(localStorage.getItem('utilisateur'));

        if (!utilisateurCourant) {
            return false;
        }

        return utilisateurCourant.exclusionControleAgePiece;
    }

}


// Exemple de données pour un utilisateur simple magasin :
//{
//	"id": 227,
//	"nom": "COMPTOIR TOULOUSE SUD",
//	"prenom": null,
//	"codePO": "C46",
//	"codePoste": "MAG",
//	"codeDepot": "46",
//	"avatar": null,
//	"groupes": [{
//			"id": 13,
//			"code": "MAGASIN",
//			"adminOuPilote": false
//		}
//	],
//	"administrateur": false,
//	"lectureSeule": false,
//	"autoriseCreationReclamationLiee": false,
//	"autoriseSAV": false,
//	"token": "..."
//}